export default __webpack_public_path__ + "static/media/sample.11376f4c.png";